export const SHOW_ERROR = "errors:show_error"
export const HIDE_ERROR = "errors:hide_error"

export const FLUSH_CART_STORE = "errors:flush_cart_store"
